import { useAuth0 } from "@auth0/auth0-react";
import { useHandleAccessToken } from "../hooks/useHandleAccessToken";

const Admin = (props) => {
  return (
    <div className="main">
      <p>admin</p>
    </div>
  );
};

export default Admin;
